var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" v"+_vm._s(_vm.version)+" ")]),_vm._l((_vm.releaseNotes),function(note){return _c('div',{staticClass:"ml-3"},[_vm._v(" "+_vm._s(note.split("&nbsp;").join(' '))+" "),_c('br')])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }